@import "~@uipath/apollo-core/src/scss/base-host.scss";
@import "~@uipath/apollo-core/src/scss/_variables.scss";
@import url("https://fonts.googleapis.com/icon?family=Material+Icons|Material+Icons+Outlined");
@import "../../utils/mixins/mixins.scss";

.main-container {
    display: flex;
    flex-direction: row;
}

.info-panel {
    display: flex;
    flex-direction: column;
    flex-basis: 0;
    flex-grow: 1;
    padding: 32px;
    background-color: var(--color-background-secondary);
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}

.start-trial-panel{
    display: flex;
    flex-direction: column;
    flex-basis: 0;
    flex-grow: 1;
    padding: 72px 12px 32px 32px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    box-sizing: border-box
}

.start-trial-header {
    font-weight: $font-weight-bold;
    font-size: $font-header-3-size;
    margin: 0px 0px 8px 0px;
}

.start-trial-description {
    font-weight: $font-weight-default;
    font-size: $font-m-size;
    margin: 0px;
}

.description-text {
    font-weight: $font-weight-default;
    font-size: $font-m-size;
    &.spacing-top {
        margin-top: 28px;
    }
}

.centered-bullet-points {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
}

.description-icons {
    color: var(--color-logo);
    margin-top: 24px;
}

.text-input{
    color: var(--color-foreground);
    background-color: var(--color-background);
    font-family: $font-normal;
    font-size: $font-m-size;
    line-height: $font-m-line-height;
    width: 100%;
    height: 40px;

    resize: none;
    border: 1px solid var(--color-border);
    border-radius: 4px;
    outline: none;
    overflow: none;
    overflow-y: hidden;
    word-wrap: none;
    margin-top: 8px;
    margin-bottom: 36px;
    padding: 4px;

    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }

.portal-button {
    @include portal-button();
    width: 100%;
  }

  .pricing-button {
    align-self: center;
    margin-top: 20px;
  }
